import {ref} from 'vue';

export default {
    install: (app, options) => {
        const subscriptionsStatuses = ref([]);
        const subscriptionsTypes = ref([]);
        const subscriptionsCompanies = ref([]);

        const loadSubscriptionsParameters = () => {
            window.lazy_axios.get(`/subscriptions/parameters`)
                .then((response) => {
                    if (response.data.statuses) {
                        subscriptionsStatuses.value = response.data.statuses;
                    }
                    if (response.data.types) {
                        subscriptionsTypes.value = response.data.types;
                    }
                    if (response.data.companies) {
                        subscriptionsCompanies.value = response.data.companies;
                    }
                });
        };

        app.provide('subscriptionsStatuses', subscriptionsStatuses);
        app.provide('subscriptionsTypes', subscriptionsTypes);
        app.provide('subscriptionsCompanies', subscriptionsCompanies);
        app.provide('loadSubscriptionsParameters', loadSubscriptionsParameters);
    },
}
